export const servicesData = {
  services_main: {
    title_01_ua: 'Онлайн уроки',
    title_02_ua: 'англійської',
    title_03_ua: 'Мови',
    title_01_ru: 'Онлайн уроки',
    title_02_ru: 'Английского',
    title_03_ru: 'Языка',
  },
  services_packages: {
    ticker: {
      id: 'abra09875',
      ticker_ua: 'Більше уроків - Менше вартість',
      ticker_ru: 'Больше уроков - Меньше стоимость',
    },
    titles: {
      title_ua: 'Онлайн уроки',
      title_ru: 'Онлайн уроки',
      sub_title_ua: 'англійської мови',
      sub_title_ru: 'английского языка',
    },

    packages: [
      {
        duration_ua: '1 Місяць',
        duration_ru: '1 Месяц',
        rate_ua: 'Тариф лайт',
        rate_ru: 'Тариф лайт',
        number_lessons: 8,
        price_uah: '2000',
        price_rub: '5500',
        price_usd: '76',
        price_eur: '66',
        sale_uah: '1000',
        sale_rub: '2750',
        sale_usd: '38',
        sale_eur: '33',
      },
      {
        duration_ua: '2 Місяці',
        duration_ru: '2 Месяца',
        rate_ua: 'Тариф Стандарт',
        rate_ru: 'Тариф Стандарт',
        number_lessons: 16,
        price_uah: '3840',
        price_rub: '10500',
        price_usd: '146',
        price_eur: '126',
        sale_uah: '1920',
        sale_rub: '5250',
        sale_usd: '73',
        sale_eur: '63',
      },
      {
        duration_ua: '4 Місяці',
        duration_ru: '4 Месяца',
        rate_ua: 'Тариф Преміум',
        rate_ru: 'Тариф Премиум',
        number_lessons: 32,
        price_uah: '7360',
        price_rub: '20156',
        price_usd: '279',
        price_eur: '240',
        sale_uah: '3680',
        sale_rub: '10078',
        sale_usd: '140',
        sale_eur: '120',
      },
    ],
  },
  approach: {
    title_ua: 'Підхід школи до навчання',
    title_ru: 'Подход школы к обучению',
    items: [
      {
        count: '01.',
        title_ua: 'Безкоштовні пробні заняття',
        title_ru: 'Бесплатные пробные уроки',
      },
      {
        count: '02.',
        title_ua: 'Індивідуальна програма',
        title_ru: 'Индивидуальная программа',
      },
      {
        count: '03.',
        title_ua: "Робота з усіма типами пам'яті",
        title_ru: 'Работа со всеми типами памяти',
      },
      {
        count: '04.',
        title_ua: 'Підготовка для роботи за кордоном',
        title_ru: 'Подготовка для работы за границей',
      },
      {
        count: '05.',
        title_ua: 'Підготовка для отримання візи',
        title_ru: 'Подготовка для получения визы',
      },
      {
        count: '06.',
        title_ua: 'Підготовка для проходження співбесіди',
        title_ru: 'Подготовка к прохождению собеседования',
      },
      {
        count: '07.',
        title_ua: 'IT програма навчання',
        title_ru: 'IT программа обучения',
      },
      {
        count: '08.',
        title_ua: 'Розмовні заняття',
        title_ru: 'Разговорные занятия',
      },
      {
        count: '09.',
        title_ua: "Запам'ятовування методом асоціацій",
        title_ru: 'Запоминание методом ассоциации',
      },
    ],
  },
  services_guides: {
    marker_ua: 'Корисні матеріали',
    marker_ru: 'Полезные материалы',
    title_ua: 'Завантажуйте гайд по вимові і говоріть завжди гарно!',
    title_ru: 'Загружайте гайд по произношению и говорите всегда хорошо!',
  },
  services_faq: {
    title_ua: 'Відповіді на ваші запитання',
    title_ru: 'Ответы на ваши вопросы',
    items: [
      {
        id: 'abra123',
        question_ua: 'Чи буде домашнє завдання?',
        question_ru: 'Будет ли домашнее задание?',
        answer_ua:
          'Звичайно буде! А ви що думали пропетляете від нашої креативної домашки? Фігушки вам! Звичайно буде! А ви що думали пропетляете від нашої креативної домашки? Фігушки вам! Звичайно буде! А ви що думали пропетляете від нашої креативної домашки? Фігушки вам! Звичайно буде! А ви що думали пропетляете від нашої креативної домашки? Фігушки вам!',
        answer_ru:
          'Конечно будет! А вы что думали пропетляете от нашей креативной домашки? Фигушки вам! Конечно будет! А вы что думали пропетляете от нашей креативной домашки? Фигушки вам! Конечно будет! А вы что думали пропетляете от нашей креативной домашки? Фигушки вам! Конечно будет! А вы что думали пропетляете от нашей креативной домашки? Фигушки вам! Конечно будет! А вы что думали пропетляете от нашей креативной домашки? Фигушки вам!',
      },
      {
        id: 'abra124',
        question_ua: 'Чи буде домашнє завдання?',
        question_ru: 'Будет ли домашнее задание?',
        answer_ua:
          'Звичайно буде! А ви що думали пропетляете від нашої креативної домашки? Фігушки вам!',
        answer_ru:
          'Конечно будет! А вы что думали пропетляете от нашей креативной домашки? Фигушки вам!',
      },
      {
        id: 'abra125',
        question_ua: 'Чи буде домашнє завдання?',
        question_ru: 'Будет ли домашнее задание?',
        answer_ua:
          'Звичайно буде! А ви що думали пропетляете від нашої креативної домашки? Фігушки вам!',
        answer_ru:
          'Конечно будет! А вы что думали пропетляете от нашей креативной домашки? Фигушки вам!',
      },
      {
        id: 'abra126',
        question_ua: 'Чи буде домашнє завдання?',
        question_ru: 'Будет ли домашнее задание?',
        answer_ua:
          'Звичайно буде! А ви що думали пропетляете від нашої креативної домашки? Фігушки вам!',
        answer_ru:
          'Конечно будет! А вы что думали пропетляете от нашей креативной домашки? Фигушки вам!',
      },
      {
        id: 'abra127',
        question_ua: 'Чи буде домашнє завдання?',
        question_ru: 'Будет ли домашнее задание?',
        answer_ua:
          'Звичайно буде! А ви що думали пропетляете від нашої креативної домашки? Фігушки вам!',
        answer_ru:
          'Конечно будет! А вы что думали пропетляете от нашей креативной домашки? Фигушки вам!',
      },
      {
        id: 'abra128',
        question_ua: 'Чи буде домашнє завдання?',
        question_ru: 'Будет ли домашнее задание?',
        answer_ua:
          'Звичайно буде! А ви що думали пропетляете від нашої креативної домашки? Фігушки вам!',
        answer_ru:
          'Конечно будет! А вы что думали пропетляете от нашей креативной домашки? Фигушки вам!',
      },
      {
        id: 'abra129',
        question_ua: 'Чи буде домашнє завдання?',
        question_ru: 'Будет ли домашнее задание?',
        answer_ua:
          'Звичайно буде! А ви що думали пропетляете від нашої креативної домашки? Фігушки вам!',
        answer_ru:
          'Конечно будет! А вы что думали пропетляете от нашей креативной домашки? Фигушки вам!',
      },
      {
        id: 'abra130',
        question_ua: 'Чи буде домашнє завдання?',
        question_ru: 'Будет ли домашнее задание?',
        answer_ua:
          'Звичайно буде! А ви що думали пропетляете від нашої креативної домашки? Фігушки вам!',
        answer_ru:
          'Конечно будет! А вы что думали пропетляете от нашей креативной домашки? Фигушки вам!',
      },
    ],
  },

  trial_lesson: {
    title_ua: 'Сумніваєшся? \nСпробуй пробний урок! \nТобі сподобається!',
    title_ru: 'Сомневаешься? \nПопробуй пробный урок! \nТебе понравится!',
  },
};
